export default "__VITE_ASSET__K_GztpB3__"